import { render, staticRenderFns } from "./StatsCardServiam.vue?vue&type=template&id=c954b91e&scoped=true&"
import script from "./StatsCardServiam.vue?vue&type=script&lang=js&"
export * from "./StatsCardServiam.vue?vue&type=script&lang=js&"
import style0 from "./StatsCardServiam.vue?vue&type=style&index=0&id=c954b91e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c954b91e",
  null
  
)

export default component.exports